import { c as _c } from "react/compiler-runtime";
import ImgWrapper from '@components/img-wrapper/ImgWrapper';
import progressLink from '@images/svg/progressLink.svg';
import NextImage from 'next/image';
import Link from 'next/link';
import styles from '../../ProgressSlide.module.scss';
const RenderLink = t0 => {
  const $ = _c(17);
  const {
    general,
    imgStyle,
    item,
    classNameImg,
    imgPreview,
    imgCount,
    videoCount
  } = t0;
  let t1;
  if ($[0] !== imgPreview) {
    t1 = imgPreview?.replace(/ /g, "%20").replace("http://", "https://");
    $[0] = imgPreview;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const normalizeImgUrl = t1;
  const t2 = general ? styles.generalCard : styles.card;
  const t3 = `progress/${item?.slug}`;
  let t4;
  if ($[2] !== normalizeImgUrl) {
    t4 = <ImgWrapper imgUrl={normalizeImgUrl} alt="progress slide" />;
    $[2] = normalizeImgUrl;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== classNameImg || $[5] !== imgStyle || $[6] !== t4) {
    t5 = <span style={imgStyle} className={classNameImg}>{t4}</span>;
    $[4] = classNameImg;
    $[5] = imgStyle;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className={styles.svgBox}><NextImage src={progressLink.src} fill={true} alt={"\u0438\u043A\u043E\u043D\u043A\u0430 \u0441\u0442\u0440\u0435\u043B\u043A\u0438"} className={styles.svg} /></span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = imgCount && `${imgCount} фото`;
  const t8 = Boolean(videoCount) && ` и ${videoCount} видео`;
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <span className={styles.card__overlay}>{t6}<p className={styles.contentLength}>{t7}{t8}</p></span>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5 || $[15] !== t9) {
    t10 = <Link className={t2} href={t3}>{t5}{t9}</Link>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default RenderLink;